module.exports = __webpack_public_path__ + "img/f2c44341b493aed0e4010c48e45ed7b3.png";